import { IResultMessage } from "@multiweb/types/contracts";
import { IOWObjectList } from "../../../../OW.Remoting/Remoting/DataTypes/IOWObjectList";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { MenuType } from "../../../UI.Controls/Actions/MenuType";
import { FormContext, IWindowableParameters } from "../UIManagerInterfaces";
import { OpenModeType } from "../XGControls/Actions/DetailFormAction";
import { IHideButtons } from "../XGControls/Frames";
import { IMasterableFrame } from "../XGControls/Frames/FrameInterfaces";
import { FormLayout, FrameRefreshType, IForm } from "../XGControls/IForm";
import { IFrame } from "../XGControls/IFrame";

export interface IFRMParams extends IWindowableParameters {
    /**
     * Frame, který se nastaví jako nadřízený frame DetailFramu na otevíraném formuláři.
     * DetailFrame pak zobrazuje a pracuje se záznamem vybraným v nadřízeném framu.
     * Možné použít pouze pro detailové formuláře.
     */
    detailFormMasterFrame?: IMasterableFrame;
    /**
     * Aplikační záznam, který bude zobrazen v detailovém formuláři.
     * Záznam zobrazovaný na detailovém formuláři se bere z detailFormMasterFrame nebo z této vlastnosti.
     */
    detailFormObject?: OWObject;
    /**
     * Zda má být viditelný pouze DetailFrame.
     * U detailových formulářů je tato vlastnost implicitně true, jinak false.
     * Nastavení na jinou hodnotu než undefined přebíjí implicitní nastavení.
     */
    visibleOnlyDetail?: boolean;
    masterObject?: OWObject;
    /** Vlastnost umožňující předání více vybraných aplikačních záznamů do formuláře současně. */
    masterObjectList?: IOWObjectList;
    masterLinkToAttr?: string;
    /** Podmínka pro čtení dat. Připojuje se k podmínce hlavního framu. */
    condition?: string;
    /** Názvy aplikačních atributů, v nichž jsou hodnoty k parametrům podmínky */
    conditionParamsAttrs?: string[];
    /** Instance aplikačního záznamu, ze kterého se načítají hodnoty parametrů podmínky */
    conditionParamsObject?: OWObject;
    applyLOVCondition?: boolean;
    ownerForm?: IForm;
    executerFrame?: IFrame;
    showDetail?: boolean;
    /** Id profilu formuláře, který se má po otevření formuláře aplikovat */
    applyFormProfileId?: number;
    openMode?: OpenModeType;
    /** Typ otevíraného formuláře (klasický/parametrický a případně typ parametrického formuláře) */
    purposeType?: MenuType;
    readVersioned?: boolean;
    /**
    * Seznam hodnot plněných po otevření formuláře.
    * Seznam ve tvaru nazev1=hodnota1;nazev2=hodnota2... Lze nastavovat atributy a auxvalues.
    */
    setValues?: string;
    /** Zda mají být u takto otevřeného formuláře skryty akce pro otevření do nového okna/záložky */
    hideWindowActions?: boolean;
    inLOVMode?: boolean;
    enableLOVSelect?: boolean;
    isModal?: boolean;
    viewMode?: boolean;
    /**
     * Nastavení viditelnosti tlačítek na hlavním framu, které přepisuje nastavení z formuláře
     */
    hideButtons?: IHideButtons;

    /** Automaticky vybere první záznam v hlavním framu otevíraného formuláře a načte jeho data */
    autoSelectFirstRow?: boolean;
    /** Automaticky vybere první záznam v hlavním framu otevíraného formuláře pouze pokud byl načten pouze jeden záznam */
    autoSelectOnlyIfOneRow?: boolean;

    /** Zda je otevren v rezimu editace vice zaznamu */
    multiEditMode?: boolean;
    /** Id záznamu, který se má vybrat v hlavním framu otevíraného formuláře */
    selectedID?: string;
    openInEdit?: boolean;
    /**Pri zmene aktivnich oken spusti refresh ActualObject na tomto seznamu*/
    frameToRefreshAfterSetFormActive?: IFrame;
    /**
     * Určuje, zda a jakým způsobem má dojít k refreshi framu nastaveném v frameToRefreshAfterSetFormActive
     */
    frameRefreshType?: FrameRefreshType;
    /**
     * Název třídy zakládaného záznamu při OpenMode.insert
     * Pokud je uvedeno, tak se zakládá záznam této třídy místo třídy uvedené na framu (tam bude pravděpodobně předek)
     */
    insertObjectName?: string;
    /**
     * Zprávy, které se zobrazí při otevření formuláře
     */
    messages?: readonly IResultMessage[];

    /**
     * Slouží pro přednaplnění atributů, při vytváření nového objektu na formuláři (TODO: obezlička kvůli ztratě kontextu mezi IFramy, takže po odstranění iFramu je možno smazat)
     */
    setAttributesOnNewObject?: { attrName: string; value: string }[];

    isFromMainMenu?: boolean;
    /** Id položky menu, ze které byl formulář otevřený. Pokud nebyl otevřený z menu, bude hodnota undefined. */
    menuItemId?: number;
    /** Pokud je nastaveno na true, tak otevřený parametrický formulář vrací svou aplikační instanci. Volající se stává zodpovědným za její uvolnění! */
    returnMainInstance?: boolean;
    /** Kontext formuláře */
    formContext?: FormContext;
    /**
     * Metoda která navrací identifikační číslo transakčního kontextu.
     * Vyplňuje se pouze pokud je potřeba předat kontext mezi formuláři
     */
    readonly transactionContextGetter?: () => string | undefined;
    /** Příznak, zda je formulář otevřený jako implicitní. Viz https://teaf.tescosw.cz/wiki/index.php?title=Implicitn%C3%AD_formul%C3%A1%C5%99 */
    isImplicit?: boolean;
    /**
     * Určuje layout otevíraného formuláře.
     */
    formLayout?: FormLayout;
}
